/**
 * Addon Store — widget-first (2.1).
 * Panels: pages/modules/addonstore/panels.tsx
 * Catalog: module-ui-catalog → stejné taby na /infra/nodes/:id
 * NodePicker v panelu cílí install na vybraný nod (callWidgetTool → mesh.rpc_call).
 */
import { getModuleUiById } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = getModuleUiById('addonstore');
if (!DEF) throw new Error('module-ui-catalog: addonstore missing');

export default function AddonStorePage() {
  return <ModuleWorkspace def={DEF} defaultTab='browse' />;
}
